module.exports = __webpack_public_path__ + "media/images/orni_quiz/logo_small-83c434ebf498224609ebcdc4d6612136.png";